import React from "react";

interface HeartPostIconProps {
  isLiked?: boolean;
  strokeColor?: string;
  fillColor?: string;
}

export default function HeartPostIcon({
  isLiked = false,
  strokeColor = "#FFFFFF",
  fillColor = "#FE5A97",
}: HeartPostIconProps) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.625 5.25C7.6905 5.25 4.5 8.64 4.5 12.8205C4.5 21.1875 18 30.75 18 30.75C18 30.75 31.5 21.1875 31.5 12.8205C31.5 7.641 28.3095 5.25 24.375 5.25C21.585 5.25 19.17 6.954 18 9.435C16.83 6.954 14.415 5.25 11.625 5.25Z"
        stroke={isLiked ? fillColor : strokeColor}
        fill={isLiked ? fillColor : "none"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ transition: "fill 0.3s, stroke 0.3s" }}
      />
    </svg>
  );
}
